import { Component, OnInit, HostListener } from '@angular/core'
import { Router } from '@angular/router'
import { Cluster } from '@parkupp/core'
import { ClusterService } from '../../../services/cluster.service'
import { GlobalService } from '../../../services/global.service'
import { ToastrService } from 'ngx-toastr'
import { environment } from '../../../../environments/environment'

@Component({
    selector: 'app-admin-list-clusters',
    templateUrl: './admin-list-clusters.component.html',
    styleUrls: ['./admin-list-clusters.component.scss'],
})
export class AdminListClustersComponent implements OnInit {
    clusters: Cluster[] = []
    loading = true
    baseUrl = environment.host || window.location.origin

    constructor(
        private clusterService: ClusterService,
        private router: Router,
        public globalService: GlobalService,
        private toastr: ToastrService
    ) {}

    // Close context menu when clicking elsewhere
    @HostListener('document:click')
    onDocumentClick(): void {
        this.globalService.hideContextMenu()
    }

    async ngOnInit() {
        this.clusterService.list().subscribe((clusters) => {
            this.clusters = clusters
            this.loading = false
        })
    }

    getTotalParkings(): number {
        return this.clusters.reduce((total, cluster) => total + (cluster.parkingRefs?.length || 0), 0)
    }

    viewCluster(cluster: Cluster) {
        this.router.navigate(['/cluster', cluster.$key])
    }

    editCluster(cluster: Cluster) {
        this.router.navigate(['/admin/clusters/edit', cluster.$key])
    }

    createCluster() {
        this.router.navigate(['/admin/clusters/create'])
    }

    copyClusterLink(cluster: Cluster): void {
        const url = `${this.baseUrl}/cluster/${cluster.$key}`

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url).then(
                () => {
                    this.toastr.success('Cluster link copied!')
                },
                () => {
                    this.fallbackCopy(url)
                }
            )
        } else {
            this.fallbackCopy(url)
        }
    }

    private fallbackCopy(text: string): void {
        const textArea = document.createElement('textarea')
        textArea.value = text
        textArea.style.position = 'fixed'
        textArea.style.left = '-999999px'
        textArea.style.top = '-999999px'
        document.body.appendChild(textArea)
        textArea.focus()
        textArea.select()

        try {
            const successful = document.execCommand('copy')
            if (successful) {
                this.toastr.success('Cluster link copied!')
            } else {
                this.toastr.error('Failed to copy link')
            }
        } catch (err) {
            this.toastr.error('Failed to copy link')
        }

        document.body.removeChild(textArea)
    }

    // Right-click context menu
    onClusterContextMenu(event: MouseEvent, cluster: Cluster): void {
        event.preventDefault()
        event.stopPropagation()

        this.globalService.contextMenuItems = [
            {
                label: 'View Cluster Page',
                icon: 'fa-solid fa-eye',
                action: () => {
                    this.viewCluster(cluster)
                    this.globalService.hideContextMenu()
                },
            },
            {
                label: 'Edit Cluster',
                icon: 'fa-solid fa-pen',
                action: () => {
                    this.editCluster(cluster)
                    this.globalService.hideContextMenu()
                },
            },
            {
                label: 'Copy Link',
                icon: 'fa-solid fa-link',
                action: () => {
                    this.copyClusterLink(cluster)
                    this.globalService.hideContextMenu()
                },
            },
        ]

        this.globalService.showContextMenu(event)
    }
}
